import React          from 'react';
import ReactDom       from 'react-dom';

import Const          from 'fw_const';
import Utils          from 'utils';

import ContentsTab    from 'contents_tab';

import Achievements   from '@common/influencer/parts/contents/achievements/_achievements';
import Post           from '@common/influencer/parts/contents/post';
import Label          from '@common/influencer/parts/contents/label';
import FollowerTrends from '@common/influencer/parts/contents/follower-trends';
import Profiling      from '@common/influencer/parts/contents/profiling';
// -------------------------------------------------------

class InfluencerContents extends React.Component {
  getProjects() {
    let data = this.props.data;
    
    let projects = (data.projects || []).map((d, key) => {
      
      // レポートの取得
      d.reports = [];
      if( data.reports[d.id] != undefined ) d.reports = data.reports[d.id];
      d.post_count = d.reports.length;
      
      // 指定スコア
      d.score = 0;
      try {
        d.reports.map((r) => { if( r[this.state.mode] != undefined && r[this.state.mode] != null ) d.score += r[this.state.mode]; });
      } catch(e) {}
      
      // 1スコアあたりの単価
      d.cp = (d.contract_money / d.score);
      if( isNaN(d.cp) || d.cp == 'Infinity' ) d.cp = 0;
      
      // プロジェクトモードの設定
      d.project_mode = null;
      d.project_complete = false;
      
      if( d.is_ng == 0 && d.is_assign == 1 ) d.project_mode = 'assign';
      if( d.is_ng == 0 && d.is_entry == 1 ) d.project_mode = 'ok';
      if( d.is_ng == 1 ) d.project_mode = 'ng';
      if( d.post_count > 0 ) d.project_complete = true;
      
      return d;
    });
    
    return projects.filter((d) => { if( d.project_mode != null ) return d; });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    let ng_html = null;
    if( data.is_pro_account === 0 ) ng_html = <div className="not-pro-account">プロアカウントではないため情報を表示することができません</div>;
    
    // 実績プロジェクトの取得
    data.achievements = this.getProjects.bind(this)();
    let achievement_count = ( data.achievements.length > 99 ) ? '99+' : data.achievements.length;
    
    // タブリスト
    let tabs = [
      { id: 'post',           name: '投稿',                                   html: <Post data={data} ng_html={ng_html} /> },
      { id: 'profiling',      name: 'プロファイリング',                       html: <Profiling data={data} ng_html={ng_html} refresh_ev={this.props.refresh_ev.bind(this)}  /> },
      { id: 'followers',      name: 'フォロワー推移',                         html: <FollowerTrends data={data} ng_html={ng_html} /> },
      { id: 'achievements',   name: 'アサイン実績 ('+ achievement_count +')', html: <Achievements data={data} /> },
      { id: 'label',          name: 'ラベル',                                 html: <Label data={data} refresh_ev={this.props.refresh_ev.bind(this)} ng_html={ng_html} /> },
    ];
    
    if( data.is_guest === true ){
      tabs = [
        { id: 'post',           name: '投稿',               html: <Post data={data} ng_html={ng_html} /> },
        { id: 'profiling',      name: 'プロファイリング',   html: <Profiling data={data} ng_html={ng_html} /> },
        { id: 'followers',      name: 'フォロワー推移',     html: <FollowerTrends data={data} ng_html={ng_html} /> },
      ];
    }
    
    let select_tab = tabs[0].id;
    if( this.props.tab_mode != undefined && this.props.tab_mode != null ){
      tabs.map((d) => { if( d.id == this.props.tab_mode ) select_tab = d.id; });
    }
    
    return (
      <div className="influencer-contents">
        <ContentsTab tabs={tabs} select={select_tab} font_size={16} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerContents;